import { useMemo } from "react";
import { useTable } from "react-table";
import { useNavigate } from "react-router-dom";
import { defaultDateDisplay } from "../../../../helpers";
import { Link } from "react-router-dom";
import { activityLogMap } from "../../../../routes/activityLogMap";
import primaryComponents from "../../../primaryComponents";
import { pathConstants } from "../../../../routes/pathContants";

export const useActivityLogsTable = ({ activityLogs = [] }) => {
  const navigate = useNavigate();

  const columns = useMemo(
    () => [
      {
        Header: "Date/Time",
        accessor: "event_time",
        Cell: ({ cell: { value } }) => defaultDateDisplay(value),
      },
      // {
      //   Header: "Resource ID",
      //   accessor: "resource_id",
      //   Cell: ({ cell: { value }, row }) =>
      //     value && activityLogMap?.[row?.original?.module?.name] ? (
      //       <Link
      //         to={activityLogMap?.[row?.original?.module?.name]?.details({
      //           id: value,
      //         })}
      //         className="purple--text small-text-size"
      //       >
      //         {value}
      //       </Link>
      //     ) : value ? (
      //       value
      //     ) : (
      //       "N/A"
      //     ),
      // },
      {
        Header: "Initiator",
        accessor: "initiator",
        Cell: ({ cell: { value } }) => value?.first_name || "N/A",
      },
      {
        Header: "Activity",
        accessor: "action",
        Cell: ({ cell: { value }, row }) => {
          const descriptionList = value?.split(
            row?.original?.resource_id || "-",
          );
          return (
            <>
              {row?.original?.resource_id &&
              activityLogMap?.[row?.original?.module?.name] ? (
                <>
                  {descriptionList?.[0]}(
                  <Link
                    to={activityLogMap?.[row?.original?.module?.name]?.details({
                      id: row?.original?.resource_id,
                    })}
                    className="purple--text small-text-size"
                  >
                    {row?.original?.resource_id}
                  </Link>
                  ){descriptionList?.[1]}
                </>
              ) : (
                <span>{value || "N/A"}</span>
              )}
            </>
          );
        },
      },
      {
        Header: "Action",
        Cell: ({ row }) => (
          <span>
            <primaryComponents.Button
              classNames={"btn btn--primary smallBtn"}
              onClick={() =>
                navigate(
                  pathConstants.SETTINGS_ACTIVITY_LOGS_DETAILS({
                    id: row?.original.id,
                  }),
                )
              }
            >
              View Details
            </primaryComponents.Button>
          </span>
        ),
      },
    ],
    [],
  );

  const instance = useTable({ columns, data: activityLogs });
  return {
    instance,
  };
};
